export const subMenuPlacement = ['right-start', 'left-start'];
export const dropdownMenuSeparator = { text: '', action: () => { }, path: [] };
